import { sample } from 'effector';
import {
  $stepsBlockTop, $firstStepOffset, $scrollY, getApiKeyFx,
  setStepsBlockTopFn, setFirstStepOffsetFn, setScrollYFn,
  $apiKey, getApiKeyFn, postMessageFn, postMessageFx, $buttonText,
  setButtonTextFn,
} from './index';

$stepsBlockTop.on(setStepsBlockTopFn, (_, height) => height);

$firstStepOffset.on(setFirstStepOffsetFn, (_, height) => height);

$scrollY.on(setScrollYFn, (_, scroll) => scroll);

$apiKey.on(getApiKeyFx.doneData, (_, key) => key.data);

$buttonText.on(setButtonTextFn, (_, text) => text);

sample({
  clock: getApiKeyFn,
  target: getApiKeyFx,
});

sample({
  clock: postMessageFn,
  fn: (store) => store,
  target: postMessageFx,
});

sample({
  clock: postMessageFx.doneData,
  fn: () => 'Отправить бриф',
  target: setButtonTextFn,
});
